import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Image } from '@thd-olt-component-react/image';
import './PromotionalNavigation2AcrossMobile.scss';

const PromotionalNavigation2AcrossMobile = (props) => {
  const { opts = {} } = props;
  const { cards } = opts;

  return (
    <div className="promotionalNav2__container">
      { cards && cards.map((card) => {
        const {
          link, id, heading, subheading, image = {}
        } = card;
        const { src, alt, height, width } = image;
        const imgClass = classNames({
          'img--block':height && width
        });
        return (
          <div className="promotionalNav2__card" key={id}>
            { link
            && (
              <a href={link}>
                <Image
                  className={`promotionalNav2__card__img ${imgClass}`}
                  src={src}
                  alt={alt}
                  height={height}
                  width={width}
                />
                <div className="promotionalNav2__card__textContainer">
                  <p
                    className="promotionalNav2__card__heading u__large u__bold u__display-font--black u--paddingBottom"
                  >
                    {heading}
                  </p>
                  <p className="promotionalNav2__card__subheading u__medium">
                    {subheading}
                  </p>
                </div>
              </a>
            )}
            { !link
            && (
              <>
                <Image
                  className={`promotionalNav2__card__img ${imgClass}`}
                  src={src}
                  alt={alt}
                  height={height}
                  width={width}
                />
                <div className="promotionalNav2__card__textContainer">
                  <p
                    className="promotionalNav2__card__heading u__large u__bold u__display-font--black u--paddingBottom"
                  >
                    {heading}
                  </p>
                  <p className="promotionalNav2__card__subheading u__medium">
                    {subheading}
                  </p>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

PromotionalNavigation2AcrossMobile.displayName = 'PromotionalNavigation2AcrossMobile';

PromotionalNavigation2AcrossMobile.propTypes = {
  opts: PropTypes.shape({
    cards: PropTypes.arrayOf(PropTypes.shape({
      link: PropTypes.string,
      id: PropTypes.string,
      heading: PropTypes.string,
      subheading: PropTypes.string,
      image: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
      }),
    })),
  }),
};

PromotionalNavigation2AcrossMobile.defaultProps = {
  opts: {}
};

export default PromotionalNavigation2AcrossMobile;
